import React from "react";
import { PlaceholderMessage } from "./styles";
import { ReactComponent as SignaturePlaceholder } from "./assets/placeholder-signature.svg";
import { Text } from "../../../text";
export var EmptySignatureMessage = function () { return (React.createElement(PlaceholderMessage, null,
    React.createElement("svg", { width: "300", style: { margin: "0 auto 20px", display: "block", height: "100px" } },
        React.createElement(SignaturePlaceholder, null)),
    React.createElement(Text, { fontSize: 4 }, "Please use your finger to sign here."))); };
